<template>
  <div></div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LinkOpener',
  components: {},
  props: {},
  data() {
    return {
      eventsIds: [],
    }
  },
  mounted() {
    const id = this.$Events.handleEvent('url_opening_required', this.openUrl)
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    openUrl({ url, title, subTitle, allowManyOpening }) {
      this.$Events.dispatchEvent('finish_loading')
      if (!url) return
      if (!window.openedUrls) window.openedUrls = []
      if (window.openedUrls.includes(url) && !allowManyOpening) return
      setTimeout(() => {
        window.customPrompt({
          title: title || this.$t('linkOpener.defaultTitle'),
          subTitle: subTitle || this.$t('linkOpener.defaultTitle', { url }),
        })
        window.open(url, '_blank')
        window.openedUrls.push(url)
      }, 1000)
    },
  },
  computed: {},
})
</script>
